class PrinterBuilder {
  constructor() {
    this.commands = [];
  }

  addTextLang(lang) {
    this.commands.push({ type: 'textLang', value: lang });
    return this;
  }

  addText(text) {
    this.commands.push({ type: 'text', value: text });
    return this;
  }

  addTextAlign(align) {
    this.commands.push({ type: 'textAlign', value: align });
    return this;
  }

  addTextPosition(position) {
    this.commands.push({ type: 'textPosition', value: position });
    return this;
  }

  addTextFont(font) {
    this.commands.push({ type: 'textFont', value: font });
    return this;
  }

  addTextSize(width, height) {
    this.commands.push({ type: 'textSize', params: { width, height } });
    return this;
  }

  addTextStyle(params) {
    this.commands.push({ type: 'textStyle', params });
    return this;
  }

  addFeedLine(lines) {
    this.commands.push({ type: 'feedLine', value: lines });
    return this;
  }

  addCut(type = 'feed') {
    this.commands.push({ type: 'cut', value: type });
    return this;
  }

  addImage(params) {
    this.commands.push({ type: 'image', params });
    return this;
  }

  async send() {
    const getPlugin = () => {
      if (typeof window !== 'undefined' && window.Capacitor) {
        return window.Capacitor.Plugins.EposPlugin;
      }
      throw new Error('EposPlugin not available');
    };
    
    const plugin = getPlugin();
    return plugin.printWithCommands({ commands: this.commands });
  }

  clear() {
    this.commands = [];
    return this;
  }

  getCommands() {
    return this.commands;
  }
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { PrinterBuilder };
  module.exports.PrinterBuilder = PrinterBuilder;
}

if (typeof exports !== 'undefined') {
  exports.PrinterBuilder = PrinterBuilder;
}
